import { SourceComponents } from '@updater/informant-core';
import { FieldWrapper as UDSFieldWrapper } from '@updater/ui-uds';

export const FieldWrapper: SourceComponents['FieldWrapper'] = (props) => {
  return <UDSFieldWrapper {...props} />;
};
